import { render, staticRenderFns } from "./AlocacaoElementosPrimarios.vue?vue&type=template&id=8127e3ac&scoped=true"
import script from "./script.js?vue&type=script&lang=js&external"
export * from "./script.js?vue&type=script&lang=js&external"
import style0 from "./AlocacaoElementosPrimarios.vue?vue&type=style&index=0&id=8127e3ac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8127e3ac",
  null
  
)

export default component.exports